module.exports = __webpack_public_path__ + "static/media/03B.e9102177.png";